<div class="clock">
    <mat-icon>schedule</mat-icon>
    <ng-container *ngIf="timezone != ''; else loadingTemplate">
        <h2>{{timezoneService.getCurrentTimeTimezoned(timezone).curTimeFmt}} ({{ timezone_name }})</h2>
    </ng-container>
    <ng-template #loadingTemplate>
        <mat-spinner diameter="24"></mat-spinner>
    </ng-template>
</div>